import { render, staticRenderFns } from "./product_series.vue?vue&type=template&id=6b95c6dc&scoped=true"
import script from "./product_series.vue?vue&type=script&lang=js"
export * from "./product_series.vue?vue&type=script&lang=js"
import style0 from "./product_series.vue?vue&type=style&index=0&id=6b95c6dc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95c6dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b95c6dc')) {
      api.createRecord('6b95c6dc', component.options)
    } else {
      api.reload('6b95c6dc', component.options)
    }
    module.hot.accept("./product_series.vue?vue&type=template&id=6b95c6dc&scoped=true", function () {
      api.rerender('6b95c6dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/new_product_apply/form/product_series.vue"
export default component.exports